<div class="main-content">
  <div class="inbt-homepage">
    <div class="product-banner" id="caraousel-scroll">
      <div #carousel *ngIf="utils.screenSizeObj.width >768 && webBannerList" class="position-relative">
        <owl-carousel-o [options]="utils.customOptionsForBanner" (changed)="handleSlideChange($event, 'web')" #owlCar>
          <ng-container *ngFor="let slideData of webBannerList ; let i = index;">
            <ng-template carouselSlide>
              <a [href]="slideData.link" (click)="triggerBannerClick(slideData)">
                <img loading="lazy" role="button" [src]="slideData.image" [alt]="slideData.altTag">
              </a>
            </ng-template>
          </ng-container>
        </owl-carousel-o>

         <!-- Navigation Buttons -->
         <button class="owl-nav d-flex justify-content-center align-items-center owl-prev" *ngIf=" webBannerList && webBannerList.length >=2" (click)="owlCar.prev()">
          <svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 40 40" focusable="false" aria-hidden="true" data-di-res-id="ca1abdf8-d437167" data-di-rand="1725952672698">
            <g fill="none" fill-rule="evenodd">
              <g>
                <circle cx="20" cy="20" r="20"></circle>
                <g fill-rule="nonzero">
                  <path d="M15.179 3.173L16.043 4.077 7.765 12 16.043 19.923 15.179 20.827 5.957 12z" transform="translate(8 8)" fill="#ffffff"></path>
                </g>
              </g>
            </g>
          </svg>
        </button>
        <button class="owl-nav d-flex justify-content-center align-items-center owl-next" *ngIf=" webBannerList && webBannerList.length >=2" (click)="owlCar.next()">
          <svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 40 40" focusable="false" aria-hidden="true" data-di-res-id="72a6da9d-f8bd046d" data-di-rand="1725952672699">
            <g>
              <circle cx="20" cy="20" r="20"></circle>
              <g fill-rule="nonzero">
                <path d="M7.957 4.077L8.821 3.173 18.043 12 8.821 20.827 7.957 19.923 16.235 12z" transform="translate(8 8)" fill="#ffffff"></path>
              </g>
            </g>
          </svg>    
        </button>
      </div>
      <div #carousel *ngIf="utils.screenSizeObj.width <=768 && mobileBannerList" class="position-relative">
        <owl-carousel-o [options]="utils.customOptionsForBanner" (changed)="handleSlideChange($event, 'mob')">
          <ng-container *ngFor="let slideData of mobileBannerList; let i = index;">
            <ng-template carouselSlide>
              <a [href]="slideData.link" (click)="triggerBannerClick(slideData)">
                <img loading="lazy" role="button" [src]="slideData.image" [alt]="slideData.altTag">
              </a>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
    <!-- <div class="smallBannerSection halfBannerSection" *ngIf="halfBannerSection && halfBannerSection.length">
      <div class="container">
        <div #carousel class="position-relative">
          <owl-carousel-o [options]="utils.optionForBannerArea">
            <ng-container *ngFor="let slideData of halfBannerSection">
              <ng-template carouselSlide>
                <a class="w-100" [href]="slideData.link" (click)="triggerBannerClick(slideData)">
                  <img class="w-100" role="button" [src]="slideData.image" [alt]="slideData.altTag">
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </div>
    </div> -->
    <div class="products shopByCat"
      *ngIf="eshopHomeData && eshopHomeData.eShopCategoryList && eshopHomeData.eShopCategoryList.length">
      <div class="container">
        <h1 class="headertext">Shop by category</h1>
        <div *ngIf="categoryCarousalData && categoryCarousalData.length">
          <app-carousal-page [centered]="true" [isCategoryCarousel]="true" [genericCarousel]="true"
            [carouselSlideData]="categoryCarousalData" [isProductCarousel]="true"
            (catClicked)="categoryClicked()"></app-carousal-page>
        </div>
      </div>
    </div>
    <div class="hot-offers" *ngIf="hotOffersSection && hotOffersSection.name">
      <div class="container">
        <h3>{{hotOffersSection.name?hotOffersSection.name:'Hot Offers'}}</h3>
        <app-carousal-page [genericCarousel]="true" [centered]="true" [isEshop]="true"  [carouselSlideData]="hotOffersSection.banner">
        </app-carousal-page>
      </div>
    </div>
    <div class="top-deal" *ngIf="topDealsSection && topDealsSection.name">
      <div class="container">
        <h3>{{topDealsSection.name?topDealsSection.name:'Top Deals'}}</h3>
        <app-carousal-page [genericCarousel]="true" [centered]="true" [isEshop]="true" [carouselSlideData]="topDealsSection.banner">
        </app-carousal-page>
      </div>
    </div>
    <div class="top-deal" *ngIf="topDealsSectiontwo && topDealsSectiontwo.name">
      <div class="container">
        <h3>{{topDealsSectiontwo.name?topDealsSectiontwo.name:'Hot Offers'}}</h3>
        <app-carousal-page [genericCarousel]="true" [centered]="true" [isEshop]="true" [carouselSlideData]="topDealsSectiontwo.banner">
        </app-carousal-page>
      </div>
    </div>
    <div class="our-product bgWhite" *ngIf="productCarousalData && productCarousalData.length">
      <div class="container">
        <h3>Our Products</h3>
        <app-carousal-page [genericCarousel]="true" [carouselSlideData]="productCarousalData" [isProductCarousel]="true"
          (imageClicked)="onProductClick($event)"></app-carousal-page>
      </div>
    </div>
  <app-help-support></app-help-support>
  </div>
</div>
